import { fireBIEvent } from 'public/bi-events.js';
import wixLocation from 'wix-location';

$w.onReady(function () {

    const url = wixLocation.url;

    const ctas = [
        '#button10',
        '#button8',
        '#button9',
        '#button6',
        '#button7',
        '#button5',
        '#button3',
    ]
    const boxes = [
        '#box5',
        '#box6',
        '#box7',
        '#box8',
        '#box9',
        '#box10',
        '#box11',
    ]

    boxes.forEach((box, index) => {
        $w(box).onClick(() => {
            const biFields = {
                button_name: $w(ctas[index]).label,
                topic: 'Get Your Own Stunning Website',
                url,
                is_valid: true
            }
            fireBIEvent(19, 703, biFields);
        });

    });

});